export default __webpack_public_path__ + "static/media/Rubik-SemiBold.779458cb.ttf";